import React, { Component } from 'react';
import { bool, func, string } from 'prop-types';

import { connect } from 'react-redux';

import { isEmpty } from 'lodash';

import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import EsmsDialog from '../../components/EsmsDialog';

import validator from '../../helpers/validator';

import * as ArchitectActions from '../../actions/architectActions';
import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as UiActions from '../../actions/uiActions';

import classes from './CreateEntityModal.module.css';

class CreateEquipmentAreaModal extends Component {
    state = {
        formIsValid:     false,
        open:            null,
        filteredOptions: [],
        formControls:    {
            areas: {
                value:           [],
                ids:             [],
                placeholder:     'Select Areas',
                valid:           false,
                touched:         false,
                message:         '',
                validationRules: {
                    isNonemptyArray: true
                }
            }
        }
    }

    resetModal = () => {
        const options = this.setOptions();

        const updatedControls = this.setForm();

        this.setState({
            filteredOptions: options,
            formControls:    updatedControls,
            formIsValid:     false
        });
    }

    setForm = () => {
        const updatedControls = {
            ...this.state.formControls
        };

        for (let formControl in updatedControls) {
            updatedControls[formControl].value = [];
            updatedControls[formControl].ids = [];
            updatedControls[formControl].touched = false;
            updatedControls[formControl].valid = false;
        }

        return updatedControls;
    }

    setOptions = () => {
        const { areas, filteredAreas } = this.props;

        const normalized = filteredAreas.map(({ id }) => id);

        return areas.filter(value => !normalized.includes(value.id));
    }

    handleValidation = event => {
        const validatedState = validator(this.state, event);

        this.setState({
            formControls: validatedState.updatedControls,
            formIsValid:  validatedState.formIsValid
        });
    }

    handleChange = (event, index) => {
        const value = event.target.value;
        const name = event.target.name;
        // Defect in Material UI, '.$' is being prepended to the key prop of the
        // react synthetic object coming in as "index"
        const id = index.key.replace('.$', '');

        const updatedControls = { ...this.state.formControls };

        this.props.toggleLoading(false);

        updatedControls[name].value = value;
        updatedControls[name].ids = updatedControls[name].ids.includes(id)
            ? updatedControls[name].ids.filter(c => c !== id)
            : [...updatedControls[name].ids, id];

        this.setState({
            formControls: updatedControls
        });
    }

    handleCreate = async () => {
        const {
            clearErrors,
            createEquipmentArea,
            selectedNode,
            selectedSite
        } = this.props;
        let isCreated;

        clearErrors();

        if (!this.props.isLoading) {
            this.props.toggleLoading(true);
            isCreated = await createEquipmentArea(
                this.state.formControls.areas.ids,
                selectedNode.id,
                selectedSite.id
            );
        }

        if (isCreated) this.handleClose();
    }

    handleClose = () => {
        this.props.clearErrors();
        this.props.toggleLoading(false);
        this.props.close();
    }

    render() {
        const {
            errors,
            isLoading,
            open,
            title
        } = this.props;

        return (
            <EsmsDialog
                errors={errors}
                open={open}
                onClose={this.handleClose}
                title={title}
                onRendered={this.resetModal}
                onConfirm={this.handleCreate}
                disabled={isEmpty(this.state.formControls.areas.ids)}
                isLoading={isLoading}
                confirmText="Create"
            >
                <div className={classes.formColumn}>
                    <div className={classes.labelColumn}>
                        <div className={classes.labelHeader}>
                            <img src="/assets/images/equipmentTreeIcon.svg" alt="equipment icon" />
                            <span>Add Equipment to Areas</span>
                        </div>
                        <div className={classes.labelContent}>
                            <p>
                                Select the Areas to assign the piece of Equipment to.
                            </p>
                            <p>
                                Areas already associated with this piece of Equipment will not appear in the list.
                            </p>
                        </div>
                    </div>
                    <div className={classes.inputColumn}>
                        <div className={classes.inputs}>
                            <FormControl className={classes.fullWidth}>
                                <InputLabel
                                    htmlFor="areas"
                                    classes={{
                                        focused: classes.labelFocused,
                                        root:    classes.label
                                    }}
                                >
                                    {this.state.formControls.areas.placeholder}
                                </InputLabel>
                                <Select
                                    multiple
                                    value={this.state.formControls.areas.value}
                                    id="areas"
                                    input={<Input id="select-multiple-checkbox" />}
                                    renderValue={selected => selected.join(', ')}
                                    onChange={this.handleChange}
                                    name="site"
                                    className={`${classes.cssUnderline} ${classes.input}`}
                                    inputProps={{
                                        name:   'areas',
                                        id:     'areas',
                                        onBlur: this.handleValidation
                                    }}
                                >
                                    {
                                        this.state.filteredOptions.map(area => (
                                            <MenuItem
                                                className={classes.selectMenuItem}
                                                value={area.name}
                                                key={area.id}
                                            >
                                                <Checkbox
                                                    color="primary"
                                                    checked={this.state.formControls.areas.value.indexOf(area.name) > -1}
                                                />

                                                <span>{area.name}</span>
                                            </MenuItem>
                                        ))
                                    }
                                </Select>
                                {!this.state.formControls.areas.valid &&
                                 this.state.formControls.areas.touched && <FormHelperText className={classes.error}>{this.state.formControls.areas.message}</FormHelperText>}
                            </FormControl>
                        </div>
                    </div>
                </div>
            </EsmsDialog >
        );
    }
}


CreateEquipmentAreaModal.propTypes = {
    close: func.isRequired,
    open:  bool.isRequired,
    title: string.isRequired
};

const mapStateToProps = state => {
    return {
        areas:         state.architect.areas,
        companyInfo:   state.companyInfo,
        errors:        state.messages.errors,
        filteredAreas: state.architect.filteredAreas,
        isLoading:     state.ui.isLoading,
        selectedNode:  state.architect.selectedNode,
        selectedSite:  state.site.selectedSite
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...ApplicationMessageActions,
    ...UiActions
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateEquipmentAreaModal);
